<template>
  <v-layout>
    <v-footer class="footer-bar d-flex flex-column text-center">
      <v-row justify="center">
        <v-col class="w100 footer-links">
          <v-btn
            v-for="(url, key, index) in links"
            :key="index"
            :to="url"
            variant="text"
            color="surface_invert"
          >
            <span>{{ $t("site.subnav." + key) }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col id="copyright" cols="12">
          <strong>{{ $t("site.copyright_notice") }}</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-layout>
</template>
<script setup>
import { computed } from "vue";

import { useSiteStore } from "@/stores/site";
const siteStore = useSiteStore();
const language = computed(() => siteStore.language);

const links = {
  imprint: "/imprint",
  terms: "/site/terms" + "_" + language.value,
  dataprotection: "/site/dataprotection" + "_" + language.value,
};
</script>
